<template>
	<CRow>
		<CCol sm="6">
			<CAlert color="primary" closeButton :show.sync="alert1">توجه! لیست سیاه هر روز ساعت ۰۷:۳۰ صبح به‌روزرسانی می‌شود.</CAlert>
		</CCol>
		<CCol sm="12">
			<CButton @click="collapse=!collapse" color="primary" class="mb-2 ml">
				فیلتر داده‌ها
			</CButton>
            <CButton @click="redirect_to(`/blacklist/add`)" 
				v-show="$store.state.perms.can_add_black_lists" color="primary" class="mb-2 ml">
				افزودن شماره</CButton>
			<CButton @click="update_modal=true" color="primary" class="mb-2 ml">
				به‌روزرسانی شماره‌ها</CButton>
			<CCollapse :show="collapse" :duration="400">
				<CCard>
					<CCardHeader>
						<strong>گزینه‌های فیلتر</strong>
					</CCardHeader>
					<CCardBody>
						<CRow>
							<CCol sm="3">
								<CInput v-model="form.number.val" :description="form.number.inv" label="شماره" />
							</CCol>
						</CRow>
						<br>
						<div class="form-group form-actions">
							<CButton @click="validator();filter=true;page=1;get()" class="ml" color="primary">فیلتر</CButton>
							<CButton @click="remove_filter" color="danger">حذف فیلتر</CButton>
						</div>
					</CCardBody>
				</CCard>
			</CCollapse>
		</CCol>
		<CCol col="12" xl="12">
			<CCard>
				<CCardHeader>
					<strong>لیست سیاه</strong> 
					<div class="card-header-actions">
						تعداد: {{row_count}}
					</div>
				</CCardHeader>
				<CCardBody>
					<CCol sm="5">
						<CSelect v-model="limit" horizontal label="تعداد سطرها" :options="[
						{value: 10}, {value: 20}, {value: 50}, {value: 100}]" class="row-count"
						placeholder="تعداد سطرها" @change="limit=$event.target.value" />
					</CCol>
					<CDataTable hover striped :items="items" :fields="fields" :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }">
						<template #action="data">
							<td>
								<template>
									<div class="flex-container">
										<div @click="delete_modal=true;id=data.item.id"
											v-c-tooltip.hover="'حذف'"
											v-show="$store.state.perms.can_delete_users_from_user_group">
											<CIcon name="cilTrash" size="lg"/>
										</div>
									</div>
								</template>
							</td>
						</template>
          		</CDataTable>
				<br>
				<div> 
					<CPagination
					:activePage.sync="page"
					:pages="page_count"
					align="center"
					:doubleArrows="true"
					/>
				</div>
			</CCardBody>
		</CCard>
		</CCol>
		<CModal
			title="دقت کنید"
			size="sm"
			color="danger"
			:show.sync="delete_modal"
			>
			<p>آیا برای حذف شناسه {{id}} اطمینان دارید؟</p>
			<template #footer>
				<CButton @click="delete_modal=false" color="secondary">خیر</CButton>
				<CButton @click="delete_row" color="danger">بله</CButton>
			</template>
		</CModal>
		<CModal
            title="دقت کنید"
            size="sm"
            color="secondary"
            :show.sync="update_modal"
            >
            <p>آیا بابت به‌روزرسانی شماره‌ها اطمینان دارید؟</p>
            <template #footer>
                <CButton @click="update_modal=false" color="secondary">خیر</CButton>
                <CButton @click="updated_numbers" color="danger">بله</CButton>
            </template>
        </CModal>
  </CRow>
</template>

<script>
import validator from '../mixins'
export default {
    mixins: { validator },
	data() {
		return {
			row_count: '',
			items: [],
			fields: [
				{ key: 'number', label: 'شماره' },
                { key: 'action', label: 'عملیات' },
			],
			collapse: false,
			form: {
				number: {val: '', inv: '', v: {max: 16}},
			},
			disable: false,
			page: 1,
			page_count: 0,
			offset: 0,
			limit: 10,
			delete_modal: false,
			id: 0,
			close: true,
			update_modal: false,
		}
	},
	watch: {
		page: {
			handler() {
                this.get();
                window.scrollTo({ top: 0, behavior: 'smooth' });
			}
		},
		limit: {
			handler() {
				this.disable = false;
				this.get();
			}
		}
	},
	mounted() {
		this.get();
	},
	methods: {
		get() {
			if(this.disable == false){
				let filter = '';
				for (const key in this.form) {
					if(this.form[key].val != ''){
						filter += `&${key}=` + this.form[key].val;
					}
				}

				this.axios.get('black_lists/'
					+ '?count=1'
					+ filter)
					.then(res => {
						this.row_count = String(res.data.count).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        if(res.data.count > this.limit){
                            this.page_count = Math.ceil(res.data.count / this.limit);
                        } else {
                            this.page_count = 1;
                        }
						this.offset = 0;
						if(this.page != 1){
							this.offset = (this.page * this.limit) - this.limit;
						}
					})
				.finally(() => {
					this.axios.get('black_lists/'
						+ '?limit=' + this.limit
						+ '&offset=' + this.offset
						+ filter)
						.then(res => {
							this.items = res.data;
						})
				})
			}
		},
		delete_row() {
			this.axios.delete('black_lists/'
			+ this.id)
			.then(() => {
				this.$notify({
					group: 'foo',
					type: 'success',
					text: 'حذف با موفقیت انجام شد.'
				});
				this.delete_modal = false;
				this.get();
			})
			.catch(() => {
				this.$notify({
					group: 'foo',
					type: 'error',
					text: 'خطا! لطفا مجددا تلاش کنید.'
				});
				this.delete_modal = false;
			})
		},
		remove_filter() {
            for (const key in this.form) {
                this.form[key].val = '';
                this.form[key].inv = '';
            }
            this.disable = false;
            this.filter = false;
            this.page = 1;
            this.get();
        },
		redirect_to(route) {
			this.$router.push(route);
		},
		updated_numbers(){
			this.axios.get('black_lists/'
				+ '?download_blacklist=1')
				.then(() => {
					this.$notify({
						group: 'foo',
						type: 'success',
						text: 'پس از ۳۰ دقیقه شماره‌هابه‌روزرسانی ‌می‌شوند.'
					});
				})
		}
	},
	beforeCreate(){
		if(this.$store.state.perms.can_view_black_lists_page == false
			&& this.$store.state.verif == false){
			this.$router.push('/403')
		}
	},
}
</script>